import {gql} from '@apollo/client'

export const CONVERSION_SALES = gql`
  query leadsByConversionPercentage(
    $pipelineId: Int
    $stageName: String
    $startDate: Date
    $endDate: Date
  ) {
    leadsByConversionPercentage(
      pipelineId: $pipelineId
      stageName: $stageName
      startDate: $startDate
      endDate: $endDate
    )
  }
`

export const DECLINE_SALES = gql`
  query leadsByConversionPercentage(
    $pipelineId: Int
    $stageName: String
    $startDate: Date
    $endDate: Date
  ) {
    leadsByConversionPercentage(
      pipelineId: $pipelineId
      stageName: $stageName
      startDate: $startDate
      endDate: $endDate
    )
  }
`

export const GET_REPORT_SOURCE_PERCENT = gql`
  query leadsBySourcePercentage($pipelineId: Int!, $startDate: Date, $endDate: Date) {
    leadsBySourcePercentage(pipelineId: $pipelineId, startDate: $startDate, endDate: $endDate) {
      leadSource
      percentage
    }
  }
`

export const GET_REPORT_LOSS_REASON_PERCENT = gql`
  query leadsByLossReasonPercentage($pipelineId: Int!, $startDate: Date, $endDate: Date) {
    leadsByLossReasonPercentage(pipelineId: $pipelineId, startDate: $startDate, endDate: $endDate) {
      lossReason
      percentage
    }
  }
`

export const GET_TAG_PERCENT = gql`
  query leadsByTagPercentage($pipelineId: Int!, $startDate: Date, $endDate: Date) {
    leadsByTagPercentage(pipelineId: $pipelineId, startDate: $startDate, endDate: $endDate) {
      tag
      percentage
    }
  }
`

export const GET_LEADS_BY_TAG_COUNT = gql`
  query leadsByTagCount($pipelineId: Int, $tagName: String!, $startDate: Date, $endDate: Date) {
    leadsByTagCount(pipelineId: $pipelineId, tagName: $tagName, startDate: $startDate, endDate: $endDate)
  }
`

export const GET_TOTAL_LEADS = gql`
  query totalLeads($pipelineId: Int, $startDate: Date, $endDate: Date) {
    totalLeads(stagePipeline_PipelineId: $pipelineId, startDate: $startDate, endDate: $endDate)
  }
`

export const GET_USER_REPORT = gql`
  query leadsByUserMetrics($pipelineId: Int!, $startDate: Date, $endDate: Date) {
    leadsByUserMetrics(pipelineId: $pipelineId, startDate: $startDate, endDate: $endDate) {
      user
      totalLeads
      soldLeads
      declinedLeads
      successRate
      failureRate
    }
  }
`

export const GET_POLICY_REPORTS_GLOBAL = gql`
  query policyStatistics(
    $createdAfter: DateTime
    $createdBefore: DateTime
    $carrier: String
    $stateEU: String
    $policyType: String
    $status: String
  ) {
    policyStatistics(
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      carrier: $carrier
      stateEU: $stateEU
      policyType: $policyType
      status: $status
    ) {
      count
      totalCost
    }
  }
`

export const GET_POLICY_REPORTS_USERS = gql`
  query policyStatus(
    $startDate: DateTime
    $endDate: DateTime
    $pendingByDate: Boolean
    $sortOrder: String
  ) {
    policyStatus(
      startDate: $startDate
      endDate: $endDate
      pendingByDate: $pendingByDate
      sortOrder: $sortOrder
    ) {
      userStats {
        user {
          id
          firstName
          lastName
        }
        completedCount
        canceledCount
        pendingCount
      }
      totals {
        totalCompleted
        totalCanceled
        totalPending
      }
    }
  }
`

export const GET_QUOTE_REPORTS_USERS = gql`
  query quoteStatus(
    $startDate: DateTime
    $endDate: DateTime
    $pendingByDate: Boolean
    $sortOrder: String
  ) {
    quoteStatus(
      startDate: $startDate
      endDate: $endDate
      pendingByDate: $pendingByDate
      sortOrder: $sortOrder
    ) {
      userStats {
        user {
          id
          firstName
          lastName
        }
        completedCount
        canceledCount
        pendingCount
      }
      totals {
        totalCompleted
        totalCanceled
        totalPending
      }
    }
  }
`

export const GET_QUOTE_REPORTS_GLOBAL = gql`
  query quoteStatistics(
    $createdAfter: DateTime
    $createdBefore: DateTime
    $carrier: String
    $stateEU: String
    $policyType: String
    $status: String
  ) {
    quoteStatistics(
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      carrier: $carrier
      stateEU: $stateEU
      policyType: $policyType
      status: $status
    ) {
      count
      totalCost
    }
  }
`

export const GET_POLICY_DASHBOARD_SUMMARY = gql`
  query policyDashboardSummary(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
  ) {
    policyDashboardSummary(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      status: $status
      agent: $agent
    ) {
      totalPolicies
      totalApplicants
      totalPoliciesLastPeriod
      totalApplicantsLastPeriod
      growthPercentage
      periodData {
        period
        periodLabel
        policiesCount
        applicantsCount
      }
    }
  }
`

export const GET_AGENTS_LEADERBOARD = gql`
  query agentsLeaderboard(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
    $limit: Int
  ) {
    agentsLeaderboard(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      status: $status
      agent: $agent
      limit: $limit
    ) {
      user {
        id
        firstName
        lastName
        email
        avatar
      }
      policiesCount
      applicantsCount
      rank
    }
  }
`

export const GET_POLICY_TYPE_TRENDS = gql`
  query policyTypeTrends(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
  ) {
    policyTypeTrends(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      status: $status
      agent: $agent
    ) {
      period
      periodLabel
      policyTypeName
      policiesCount
    }
  }
`

export const GET_POLICY_TYPE_DISTRIBUTION = gql`
  query policyTypeDistribution(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
    $limit: Int
  ) {
    policyTypeDistribution(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      status: $status
      agent: $agent
      limit: $limit
    ) {
      policyTypeName
      policiesCount
      percentage
    }
  }
`

export const GET_CARRIER_POLICIES_DISTRIBUTION = gql`
  query carrierPoliciesDistribution(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
    $limit: Int
  ) {
    carrierPoliciesDistribution(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      status: $status
      agent: $agent
      limit: $limit
    ) {
      carrierName
      policiesCount
      percentage
    }
  }
`

export const GET_CARRIER_APPLICANTS_DISTRIBUTION = gql`
  query carrierApplicantsDistribution(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
    $limit: Int
  ) {
    carrierApplicantsDistribution(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      status: $status
      agent: $agent
      limit: $limit
    ) {
      carrierName
      applicantsCount
      percentage
    }
  }
`

export const GET_STATE_POLICIES_DISTRIBUTION = gql`
  query statePoliciesDistribution(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $policyType: [String]
    $status: [String]
    $agent: [String]
  ) {
    statePoliciesDistribution(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      policyType: $policyType
      status: $status
      agent: $agent
    ) {
      stateCode
      stateName
      policiesCount
      percentage
    }
  }
`

export const GET_STATUS_POLICIES_DISTRIBUTION = gql`
  query statusPoliciesDistribution(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $agent: [String]
    $limit: Int
  ) {
    statusPoliciesDistribution(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      agent: $agent
      limit: $limit
    ) {
      statusCode
      statusTitle
      statusColor
      policiesCount
      percentage
    }
  }
`


export const GET_ADVISORS_COMPLETED_POLICIES = gql`
  query advisorsCompletedPolicies(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $agent: [String]
    $limit: Int
  ) {
    advisorsCompletedPolicies(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      agent: $agent
      limit: $limit
    ) {
      user {
        id
        firstName
        lastName
        email
      }
      completedCount
      renewedCount
      totalActiveCount
      totalNonCanceledCount
      totalCount
      canceledCount
      completionPercentage
      renewalPercentage
      canceledPercentage
      rank
      assignmentGroupName
    }
  }
`

export const GET_AGENTS_RENEWAL_RATE = gql`
  query agentsRenewalRate(
    $dateFrom: Date!
    $dateTo: Date!
    $dateCriteria: String
    $carrier: [String]
    $stateEu: [String]
    $policyType: [String]
    $agent: [String]
    $limit: Int
  ) {
    agentsRenewalRate(
      dateFrom: $dateFrom
      dateTo: $dateTo
      dateCriteria: $dateCriteria
      carrier: $carrier
      stateEu: $stateEu
      policyType: $policyType
      agent: $agent
      limit: $limit
    ) {
      user {
        id
        firstName
        lastName
        email
      }
      completedCount
      renewedCount
      totalActiveCount
      totalNonCanceledCount
      totalCount
      canceledCount
      completionPercentage
      renewalPercentage
      canceledPercentage
      rank
    }
  }
`
